import React from 'react'
import { Route, Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { FaProductHunt, FaLayerGroup, FaUserCog, FaAward, FaUsers, FaUserCheck, FaToolbox } from 'react-icons/fa'
import { MdDashboard, MdSettings, MdShoppingCart, MdComment } from 'react-icons/md'
import { FaRegCommentDots } from 'react-icons/fa'

// import { userActions } from '../../_actions'

class NavMenu extends React.Component {
  // componentDidMount() {
  //     this.props.dispatch(userActions.getAll())
  // }
  render() {
    const { user, handleSidebarHide } = this.props;
    return (
      <ul className="nav">


        <Route path="/admin" exact>
          {({ match }) => <li onClick={handleSidebarHide} onClick={handleSidebarHide} className={match ? 'nav-item root-li active' : 'nav-item root-li'}><Link to="/admin">
            <MdDashboard className="mdi" size="24px" />
            <span>
              داشبورد
                  </span>
          </Link></li>}
        </Route>


        {user && user.userType !== undefined && [1, 2].includes(user.userType) &&
          <Route path="/admin/shops" exact>
            {({ match }) => <li onClick={handleSidebarHide} onClick={handleSidebarHide} className={match ? 'nav-item root-li active' : 'nav-item root-li'}><Link to="/admin/shops">
              <FaUserCheck className="mdi" size="24px" />
              <span>
                نمایندگان فروش
                  </span>
            </Link></li>}
          </Route>
        }
        {user && user.userType !== undefined && [1, 2].includes(user.userType) &&
          <Route path="/admin/orders" exact>
            {({ match }) => <li onClick={handleSidebarHide} onClick={handleSidebarHide} className={match ? 'nav-item root-li active' : 'nav-item root-li'}><Link to="/admin/orders">
              <MdShoppingCart className="mdi" size="24px" />
              <span>
                سفارشات
                  </span>
            </Link></li>}
          </Route>
        }
        {user && user.userType !== undefined && [1].includes(user.userType) &&
          <Route path="/admin/installers" exact>
            {({ match }) => <li onClick={handleSidebarHide} onClick={handleSidebarHide} className={match ? 'nav-item root-li active' : 'nav-item root-li'}><Link to="/admin/installers">
              <FaToolbox className="mdi" size="24px" />
              <span>
                نصاب ها
                  </span>
            </Link></li>}
          </Route>
        }
        {user && user.userType !== undefined && [1].includes(user.userType) &&
          <Route path="/admin/projects" exact>
            {({ match }) => <li onClick={handleSidebarHide} onClick={handleSidebarHide} className={match ? 'nav-item root-li active' : 'nav-item root-li'}><Link to="/admin/projects">
              <FaLayerGroup className="mdi" size="24px" />
              <span>
                پروژه ها
                  </span>
            </Link></li>}
          </Route>
        }
        {user && user.userType !== undefined && user.userType === 1 &&
          <Route path="/admin/scores" exact>
            {({ match }) => <li onClick={handleSidebarHide} onClick={handleSidebarHide} className={match ? 'nav-item root-li active' : 'nav-item root-li'}><Link to="/admin/scores">
              <FaAward className="mdi" size="24px" />
              <span>
                امتیازات
                  </span>
            </Link></li>}
          </Route>
        }
        {user && user.userType !== undefined && user.userType === 1 &&
          <Route path="/admin/messages" exact>
            {({ match }) => <li onClick={handleSidebarHide} onClick={handleSidebarHide} className={match ? 'nav-item root-li active' : 'nav-item root-li'}><Link to="/admin/messages">
              <MdComment className="mdi" size="24px" />
              <span>
                مدیریت پیام ها
                  </span>
            </Link></li>}
          </Route>

        }


        {user && user.userType !== undefined && user.userType === 1 &&
          <Route path="/admin/Settings/:path(provinces|cities)">
            {({ match }) =>
              <li className={match ? 'nav-item root-li active' : 'nav-item root-li'}>
                <a className={match ? 'nav-link' : 'nav-link collapsed'} data-toggle="collapse" aria-expanded={match ? 'true' : 'false'}
                  href="#Settings">
                  <MdSettings className="mdi" size="24px" />
                  <span>
                    اطلاعات پایه
                  </span>
                  <i className="mdi mdi-chevron-down "></i>

                </a>
                <div className={match ? 'collapse in' : 'collapse'} aria-expanded={match ? 'true' : 'false'} id="Settings">
                  <ul className="nav">
                    <Route path="/admin/products" exact>
                      {({ match }) => <li onClick={handleSidebarHide} className={match ? 'nav-item active' : 'nav-item'}><Link to="/admin/products">محصولات</Link></li>}
                    </Route>
                    <Route path="/admin/categories" exact>
                      {({ match }) => <li onClick={handleSidebarHide} className={match ? 'nav-item active' : 'nav-item'}><Link to="/admin/categories">دسته بندی ها</Link></li>}
                    </Route>
                    <Route path="/admin/Settings/provinces" exact>
                      {({ match }) => <li onClick={handleSidebarHide} className={match ? 'nav-item active' : 'nav-item'}><Link to="/admin/Settings/provinces">مدیریت استان ها</Link></li>}
                    </Route>
                    <Route path="/admin/Settings/cities" exact>
                      {({ match }) => <li onClick={handleSidebarHide} className={match ? 'nav-item active' : 'nav-item'}><Link to="/admin/Settings/cities">مدیریت شهر ها</Link></li>}
                    </Route>
                    <Route path="/admin/Settings/banks" exact>
                      {({ match }) => <li onClick={handleSidebarHide} className={match ? 'nav-item active' : 'nav-item'}><Link to="/admin/Settings/banks">مدیریت بانک ها</Link></li>}
                    </Route>
                    <Route path="/admin/users" exact>
                      {({ match }) => <li onClick={handleSidebarHide} className={match ? 'nav-item active' : 'nav-item'}><Link to="/admin/users">مدیریت کاربران</Link></li>}
                    </Route>
                  </ul>
                </div>
              </li>
            }
          </Route>
        }


      </ul>
    );
  }
}


function mapStateToProps(state) {
  const { authentication } = state;
  const { user } = authentication;
  return {
    user
  };
}

const connectedNavMenu = connect(mapStateToProps)(NavMenu);
export { connectedNavMenu as NavMenu };